import { getEnvValue } from '@env/getEnvValue'

const appIdAndKey = {
  NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION_ID: getEnvValue(process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION_ID),
  NEXT_PUBLIC_ITUNES_APP_ID: getEnvValue(process.env.NEXT_PUBLIC_ITUNES_APP_ID),
  NEXT_PUBLIC_HOTJAR_SITE_ID: getEnvValue(process.env.NEXT_PUBLIC_HOTJAR_SITE_ID),
  NEXT_PUBLIC_SEGMENT_WRITE_KEY: getEnvValue(process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY),
  NEXT_PUBLIC_GTM_KEY: getEnvValue(process.env.NEXT_PUBLIC_GTM_KEY),
  NEXT_PUBLIC_RECAPTCHA_V3_KEY: getEnvValue(process.env.NEXT_PUBLIC_RECAPTCHA_V3_KEY),
  NEXT_PUBLIC_RECAPTCHA_V2_KEY: getEnvValue(process.env.NEXT_PUBLIC_RECAPTCHA_V2_KEY)
}

export { appIdAndKey }
